import jQuery from 'jquery';
import moment from 'moment';
import autosize from 'autosize';
import { PopOver } from 'rp-prices-component';

import PdfDropDown from './pdfDropdown';
import cardPage from './cardPage';

export default class Bindings {
    constructor() {
        this.$expandCollapseBtn = jQuery('.js-RC-expandCollapseBtn');
        this.openPdfPopover = this.openPdfPopover.bind(this);
        this.openStatsModal = this.openStatsModal.bind(this);
        jQuery('body')
            .on('click', '.js-RC-runnerFormBtn', this.toggleForm)
            .on('click', '.js-RC-runnerSpotlightBtn', this.toggleSpotlight)
            .on('click', '.js-RC-runnerCommentsBtn', this.toggleComments)
            .on('click', '.js-RC-runnerNotesBtn', this.toggleNotes)
            .on('click', '.js-RC-runnerQuoteBtn', this.toggleQuotes)
            .on('reset', '.js-RC-notes', this.resizeTextarea)
            .on('click', '.js-RC-runner__excludeBtn', this.toggleRunnerExclude.bind(this))
            .on('click', '.js-RC-pdfPopover__toggleArea', this.openPdfPopover)
            .on('click', '.js-RC-stats__modalLink', this.openStatsModal);

        jQuery(document).on('dynamicPricesUpdated.NOTES', () => {
            autosize(jQuery('.js-RC-noteTextarea'));
        });

        autosize(jQuery('.js-RC-noteTextarea'));

        if (this.$expandCollapseBtn.length) {
            this.$expandCollapseBtn.on('click', this.toggleAccordionExpandCollapse);
            jQuery(document)
                .on('rp.accordion.collapsed', this.onAccordionCollapsed.bind(this))
                .on('rp.accordion.expanded', this.onAccordionExpanded.bind(this));
        }
    }

    openPopover(url, popoverConfig, popoverContainer) {
        return jQuery.ajax({
            type: 'get',
            url
        }).done((response) => {
            jQuery(popoverContainer).append(response);
            // eslint-disable-next-line no-new
            new PopOver(popoverConfig);
        });
    }

    getUrlFromDomElement(element) {
        return jQuery(element).attr('data-popover-url');
    }

    openPdfPopover(event) {
        const popoverUrl = this.getUrlFromDomElement(event.target);
        const popoverContainer = '.RC-cardTabsZone';
        const popoverConfig = {
            popOverSelector: '.RC-pdfPopover__wrapper',
            toggleAreaSelector: '.js-RC-pdfPopover__toggleArea',
            closeAreaSelectors: ['.js-pdfPopover__overlay', '.js-RC-pdfPopover__closeBtn'],
            activeClass: 'RC-pdfPopover__wrapper_active'
        };
        return this.openPopover(popoverUrl, popoverConfig, popoverContainer)
            .done(() => {
                // eslint-disable-next-line no-new
                new PdfDropDown();
                jQuery('body').off('click', '.js-RC-pdfPopover__toggleArea', this.openPdfPopover);
            })
            .fail((error) => {
                // eslint-disable-next-line no-console
                console.error('togglePdfPopover ERROR ', error);
            });
    }

    fixModalOpen() {
        if (!document || !document.getElementsByTagName) return;
        const body = document.getElementsByTagName('body');
        if (body && body[0]) {
            body[0].style.webkitOverflowScrolling = 'auto';
        }
    }

    fixModalClose() {
        if (!document || !document.getElementsByTagName) return;
        const body = document.getElementsByTagName('body');
        if (body && body[0]) {
            body[0].style.webkitOverflowScrolling = null;
        }
    }

    openStatsModal(event) {
        const popoverUrl = this.getUrlFromDomElement(event.target);
        const popoverContainer = '.RC-stats__breakdown';
        const popoverConfig = {
            popOverSelector: '.js-RC-statsModal__wrapper',
            openAreaSelectors: ['.js-RC-stats__modalLink'],
            closeAreaSelectors: ['.js-RC-statsModal__overlay', '.js-RC-statsModal__closeBtn'],
            activeClass: 'RC-statsModal__wrapper_active',
            onOpen: () => {
                cardPage.removeScroll();
                this.fixModalOpen();
            },
            onClose: () => {
                cardPage.addScroll();
                this.fixModalClose();
            }

        };

        return this.openPopover(popoverUrl, popoverConfig, popoverContainer)
            .done(cardPage.removeScroll)
            .done(this.fixModalOpen)
            .done(() => {
                jQuery('body').off('click', '.js-RC-stats__modalLink', this.openStatsModal);
            })
            .fail((error) => {
                // eslint-disable-next-line no-console
                console.error('toggleStatsModal ERROR ', error);
            });
    }

    toggleForm(event) {
        jQuery(event.target)
            .closest('.js-RC-runnerFormBtn')
            .toggleClass('RC-runnerButtons__item_active')
            .closest('.js-RC-runnerRow')
            .find('.RC-runnerForm')
            .toggleClass('RC-runnerForm_hidden');
    }

    toggleQuotes(event) {
        jQuery(event.target)
            .closest('.js-RC-runnerQuoteBtn')
            .toggleClass('RC-runnerButtons__item_active')
            .closest('.js-RC-runnerRow')
            .find('.RC-quotes')
            .toggleClass('RC-quotes_hidden');
    }

    toggleSpotlight(event) {
        jQuery(event.target)
            .closest('.js-RC-runnerSpotlightBtn')
            .toggleClass('RC-runnerButtons__item_active')
            .closest('.js-RC-runnerRow')
            .find('.RC-spotlight')
            .toggleClass('RC-spotlight_hidden');
    }

    toggleComments(event) {
        jQuery(event.target)
            .closest('.js-RC-runnerCommentsBtn')
            .toggleClass('RC-runnerButtons__item_active')
            .closest('.js-RC-runnerRow')
            .find('.RC-comments')
            .toggleClass('RC-comments_hidden');
    }

    toggleNotes(event) {
        autosize.update(jQuery(event.target)
            .closest('.js-RC-runnerNotesBtn')
            .toggleClass('RC-runnerButtons__item_active')
            .closest('.js-RC-runnerRow')
            .find('.RC-notes')
            .toggleClass('RC-notes_hidden')
            .find('textarea'));
    }

    resizeTextarea(event) {
        jQuery(event.target)
            .closest('.js-RC-runnerRow')
            .find('textarea')
            .trigger('autosize:update');
    }

    toggleRunnerExclude(event) {
        const $target = jQuery(event.target);
        const $button = $target.closest('.js-RC-runner__excludeBtn');
        const $runner = $target.closest('.js-RC-runnerRow');
        const runnerId = $runner.attr('data-ugc-runnerid');
        const raceId = jQuery('[data-card-race-id]').attr('data-card-race-id');
        const raceDate = jQuery('[data-card-race-date]').attr('data-card-race-date');

        $button.toggleClass('RC-runnerButtons__item_active');
        $runner.css('overflow-anchor', 'none');
        $runner.toggleClass('RC-runnerRow_excluded');
        $runner.toggleClass('js-runnerExcludedRunner');
        this.toggleRunnerExcludeInStorage(runnerId, raceId, raceDate);
    }

    toggleRunnerExcludeInStorage(runnerId, raceId, raceDate) {
        const excludedRunners = JSON.parse(localStorage.getItem('cdt_exd')) || {};
        const race = excludedRunners[raceId] || { runners: [] };

        function toggleRunner(runnerToToggle, runners) {
            const resultRunners = [...runners];

            if (!resultRunners.includes(runnerToToggle)) {
                resultRunners.push(runnerToToggle);
            } else {
                resultRunners.splice(runners.indexOf(runnerToToggle), 1);
            }

            return resultRunners;
        }

        excludedRunners[raceId] = {
            runners: toggleRunner(runnerId, race.runners),
            timestamp: moment(raceDate).format('x')
        };

        const actualRacesToSave = this.getActualExcludedRunners(excludedRunners);

        localStorage.setItem('cdt_exd', JSON.stringify(actualRacesToSave));
        jQuery(document).trigger('RC.runnerExcluded');
    }

    getActualExcludedRunners(racesWithExcludedRunners) {
        const endOfPreviousDay = moment().startOf('day').subtract(1, 'second');

        return Object.keys(racesWithExcludedRunners)
            .reduce((agg, raceId) => {
                const excludedRunners = agg;
                const race = racesWithExcludedRunners[raceId];
                const raceTime = moment(parseInt(race.timestamp, 10));

                if (raceTime.isAfter(endOfPreviousDay) && race.runners.length) {
                    excludedRunners[raceId] = race;
                }
                return excludedRunners;
            }, {});
    }

    toggleAccordionExpandCollapse(event) {
        const $targetButton = jQuery(event.target).closest('.js-RC-expandCollapseBtn');
        const $accordion = jQuery('.js-accordion');

        if ($targetButton.hasClass('RC-expandCollapseBtn_collapse')) {
            $accordion.trigger('rp.accordion.collapseAll');
        } else {
            $accordion.trigger('rp.accordion.expandAll');
        }
        $targetButton.toggleClass('RC-expandCollapseBtn_collapse');
    }

    onAccordionCollapsed() {
        this.$expandCollapseBtn.removeClass('RC-expandCollapseBtn_collapse');
    }

    onAccordionExpanded() {
        this.$expandCollapseBtn.addClass('RC-expandCollapseBtn_collapse');
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/bindings.js